// App JWT storage + helpers (replaces the Amplify/Cognito session).
// Contract (plan/DECISIONS.md 2026-08-20): HS256 token from POST /auth/verify,
// claims { sub, email, roles, iat, exp }, 30-day expiry, no refresh tokens.

const TOKEN_KEY = 'mx-token'

export interface TokenPayload {
  sub: number
  email: string
  roles: string[]
  iat: number
  exp: number
}

export const getToken = (): string | null => {
  if (typeof window === 'undefined') return null
  return window.localStorage.getItem(TOKEN_KEY)
}

export const setToken = (token: string) => {
  window.localStorage.setItem(TOKEN_KEY, token)
}

export const clearToken = () => {
  window.localStorage.removeItem(TOKEN_KEY)
}

export const decodeToken = (token: string): TokenPayload | null => {
  try {
    const payload = token.split('.')[1]
    return JSON.parse(
      window.atob(payload.replace(/-/g, '+').replace(/_/g, '/')),
    )
  } catch {
    return null
  }
}

// A token we should even bother sending (signature is the server's job)
export const isTokenUsable = (token: string | null): token is string => {
  if (!token) return false
  const payload = decodeToken(token)
  return !!payload?.exp && payload.exp * 1000 > Date.now()
}

export const getUsableToken = (): string | null => {
  const token = getToken()
  return isTokenUsable(token) ? token : null
}

export const getRoles = (): string[] => {
  const token = getUsableToken()
  if (!token) return []
  return decodeToken(token)?.roles ?? []
}
